import { FormBase } from 'core/components';

export default class PatientNewFlowInsuranceEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.INSURANCE',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.INSURANCE_PLACEHOLDER',
                },
                {
                    name: 'effectiveDate',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.START_DATE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.START_DATE_PLACEHOLDER',
                },
                {
                    name: 'effectiveEndDate',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.END_DATE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.END_DATE_PLACEHOLDER',
                },
                {
                    name: 'policyNumber',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.POLICY_NUMBER',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.POLICY_NUMBER_PLACEHOLDER',
                },
                {
                    name: 'contactRelationship',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.RELATIONSHIP',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.RELATIONSHIP_PLACEHOLDER',                  
                    rules: 'string'               
                },
            ],
        };
    }
}
